// extracted by mini-css-extract-plugin
module.exports = {"toggle":"style_toggle__l7McY","body":"style_body__6j3tD","doubleBg":"style_doubleBg__Gj_jR","open":"style_open__bcmQf","buttonIcon":"style_buttonIcon__rjKXu"};